import React from 'react'
import { DialogTitle } from '@mui/material'

const AlertDialogHeader = props => {
  return <DialogTitle id="dialog-title">{props.title}</DialogTitle>
}

export default AlertDialogHeader
